<template>
  <div class="profile-wrap" v-if="!isLoading">
    <div class="breadcrumb-wrap">
      <h2>KYC</h2>
      <ul class="breadcrumb">
        <li>
          <router-link :to="{name: 'Home'}"><i class="bx bxs-home"></i>Home</router-link>
        </li>
        <li>
          <router-link :to="{name: 'Dashboard'}"><i class="bx bxs-dashboard"></i>Dashboard</router-link>
        </li>
        <li>
          <span>KYC</span>
        </li>
      </ul>
    </div>
    <div class="organization-box">
      <div class="title">
        <h2>KYC status</h2>
      </div>
      <div class="flex-box">
        <div class="fields">
          <div class="widget">
            <template v-if="userKyc.kycStatus === kycStatus.APPROVED">
              <el-tag
                type="success"
                effect="light">
                Congratulations. Your KYC application has been validated!
              </el-tag>
            </template>
            <template v-if="userKyc.kycStatus === kycStatus.SUBMITTED">
              <el-tag
                type="info"
                effect="light">
                Please wait for reviewing
              </el-tag>
            </template>
            <template v-if="userKyc.kycStatus === kycStatus.REJECTED && kycRejectMessage">
              <el-tag
                type="warning"
                effect="light">
                {{ kycRejectMessage}}
              </el-tag>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="organization-box" v-if="isShowUploadForm && isMobile">
      <div class="title">
        <h2>KYC Description</h2>
      </div>
      <div class="flex-box">
        <div class="fields">
          <div class="widget">
            <p>The portrait photo and ID will be deleted from the system once the authentication process is completed.</p>
            <p> Bring the document close to the camera so that the 4 corners of the document coincide with the restricted area</p>
            <p> Take sharp pictures and full information document</p>
            <div class="widget__card">
              <div class="widget__card-content">
                <div class="content__box">
                  <div class="content__box-item">
                    <div class="item__image">
                      <img src="/images/kyc/notice-01.png" alt="notice">
                    </div>
                    <div class="item__title">Don't take too blurry photos</div>
                  </div>
                  <div class="content__box-item">
                    <div class="item__image">
                      <img src="/images/kyc/notice-02.png" alt="notice">
                    </div>
                    <div class="item__title">Don't take photo to lose the angle</div>
                  </div>
                  <div class="content__box-item">
                    <div class="item__image">
                      <img src="/images/kyc/notice-03.png" alt="notice">
                    </div>
                    <div class="item__title">Don't take photos with glare</div>
                  </div>
                  <div class="content__box-item">
                    <div class="item__image">
                      <img src="/images/kyc/notice-04.png" alt="notice">
                    </div>
                    <div class="item__title">Do not take a rotated photo</div>
                  </div>
                  <div class="content__box-item">
                    <div class="item__image">
                      <img src="/images/kyc/notice-05.png" alt="notice">
                    </div>
                    <div class="item__title">Do not flip the photo</div>
                  </div>
                  <div class="content__box-item">
                    <div class="item__image">
                      <img src="/images/kyc/notice-06.png" alt="notice">
                    </div>
                    <div class="item__title">Do not take upside-down photos</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="organization-box" :class="{ 'loading': isProcessing }">
      <div class="title">
        <h2>KYC Info</h2>
      </div>
      <div class="flex-box" v-if="isDisabledUpload">
        <div class="fields kyc">
          <div class="field">
            <div class="field-label">Document type</div>
            <div class="field-input" style="justify-content: flex-start">
              <el-radio-group :value="userKyc.type" size="mini">
                <el-radio v-for="item in options" disabled
                :key="item.value"
                :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Fullname</div>
            <div class="field-input">
              <el-input disabled :value="userKyc.kycFullname"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Date of birth</div>
            <div class="field-input">
              <el-input disabled type="text" :value="userKyc.dobTxt"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Country</div>
            <div class="field-input">
              <el-select
                v-model="userKyc.kycNationalId"
                filterable
                remote
                reserve-keyword
                disabled
                placeholder="Please enter a keyword"
                :loading="loading">
                <el-option
                  v-for="item in countries"
                  :key="item.alpha_3_code"
                  :label="item.en_short_name"
                  :value="item.alpha_3_code">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="field">
            <div class="field-label">ID/Passport number</div>
            <div class="field-input">
              <el-input disabled :value="userKyc.kycIdNumber"></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-box" v-if="!isMobile && isShowUploadForm">
        <div class="fields">
          <div class="widget__card-title">
            <el-tag
              type="warning"
              effect="light">
              You have to use mobile device to complete your KYC application.
            </el-tag>
          </div>
        </div>
      </div>
      <div class="flex-box" v-if="isShowUploadForm && isMobile">
        <div class="fields kyc">
          <div class="field">
            <div class="field-label">Fullname</div>
            <div class="field-input">
              <el-input v-model="form.fullname"></el-input>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Date of birth</div>
            <div class="field-input dob">
              <!-- <el-input type="date" v-model="form.dob"></el-input> -->
              <el-select v-model="dob.day" placeholder="Day">
                <el-option
                  v-for="item in optionsDay"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dob.month" placeholder="Month" style="margin-left: 5px; margin-right: 5px;">
                <el-option
                  v-for="item in optionsMonth"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="dob.year" placeholder="Year">
                <el-option
                  v-for="item in optionsYear"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Country</div>
            <div class="field-input">
              <el-select
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a keyword"
                :remote-method="remoteMethod"
                :loading="loading"
                v-model="form.nationalId"
                >
                <el-option
                  v-for="item in countryOptions"
                  :key="item.alpha_3_code"
                  :label="item.en_short_name"
                  :value="item.alpha_3_code">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="field">
            <div class="field-label">ID/Passport number</div>
            <div class="field-input">
              <el-input v-model="form.idNumber"></el-input>
            </div>
          </div>

          <div class="field">
            <div class="field-label">Document type</div>
            <div class="field-input">
              <el-radio-group v-model="form.type" size="mini" @change="changeType">
                <el-radio v-for="item in options" :disabled="isDisabledUpload"
                :key="item.value"
                :label="item.value">{{ item.label }}</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Frontside</div>
            <div class="field-input front">
              <el-upload
                :multiple="multiple"
                :limit="limit"
                :file-list="front.fileList"
                ref="frontImage"
                action="#"
                :class="{ 'hide-upload': front.isHideUpload }"
                :on-change="handleUploadFront"
                list-type="picture-card"
                :auto-upload="false">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span
                        v-if="!isDisabledUpload"
                        class="el-upload-list__item-delete"
                        @click="handleRemoveFront(file)"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
              </el-upload>
            </div>
          </div>
          <div class="field" v-show="form.type === 'ID'">
            <div class="field-label">Backside</div>
            <div class="field-input back">
              <el-upload
                :multiple="multiple"
                :limit="limit"
                :file-list="back.fileList"
                ref="backImage"
                action="#"
                :class="{ 'hide-upload': back.isHideUpload }"
                :on-change="handleUploadBack"
                list-type="picture-card"
                :auto-upload="false">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span
                        v-if="!isDisabledUpload"
                        class="el-upload-list__item-delete"
                        @click="handleRemoveBack(file)"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
              </el-upload>
            </div>
          </div>
          <div class="field">
            <div class="field-label">Selfie</div>
            <div class="field-input self">
              <el-upload
                :multiple="multiple"
                :limit="limit"
                :file-list="self.fileList"
                ref="selfImage"
                action="#"
                :class="{ 'hide-upload': self.isHideUpload }"
                :on-change="handleUploadSelf"
                list-type="picture-card"
                :auto-upload="false">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span
                        v-if="!isDisabledUpload"
                        class="el-upload-list__item-delete"
                        @click="handleRemoveSelf(file)"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
              </el-upload>
            </div>
          </div>
          <div class="field" v-if="!isDisabledUpload">
            <div class="field-label">&nbsp;</div>
            <div class="field-input">
              <el-button @click="upload" :disabled="!isValidated">Upload</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  <el-dialog :visible.sync="dialogVisible">
    <img width="100%" :src="dialogImageUrl" alt="">
  </el-dialog>
  </div>
</template>

<script>

import countries from '@/assets/countries.json'
export default {
  data () {
    return {
      dob: {
        day: '',
        month: '',
        year: ''
      },
      optionsDay: [
      ],
      optionsMonth: [
      ],
      optionsYear: [
      ],
      countryOptions: [],
      countries: countries,
      loading: false,
      kycStatus: {
        NONE: 'NONE',
        SUBMITTED: 'SUBMITTED',
        REJECTED: 'REJECTED',
        APPROVED: 'APPROVED'
      },
      kycRejectMessage: '',
      front: {
        fileList: [],
        isHideUpload: false,
        size: ''
      },
      back: {
        fileList: [],
        isHideUpload: false,
        size: ''
      },
      self: {
        fileList: [],
        isHideUpload: false,
        size: ''
      },
      multiple: false,
      fileList: [],
      limit: 1,
      form: {
        type: 'ID',
        fullname: '',
        dob: '',
        idNumber: '',
        nationalId: ''
      },
      isHideUploadFront: false,
      isProcessing: false,
      isLoading: true,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      options: [
        {
          label: 'Identity Card',
          value: 'ID'
        },
        {
          label: 'Passport',
          value: 'PASSPORT'
        }
      ]
    }
  },
  computed: {
    isMobile () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },
    isShowUploadForm () {
      return this.userKyc.kycStatus === this.kycStatus.NONE || this.userKyc.kycStatus === this.kycStatus.REJECTED
    },
    isDisabledUpload () {
      return this.userKyc.kycStatus === this.kycStatus.SUBMITTED || this.userKyc.kycStatus === this.kycStatus.APPROVED
    },
    isValidated () {
      const isValidInfo = this.form.fullname && this.form.nationalId && this.dob.day && this.dob.month && this.dob.year && this.form.idNumber
      if (this.isId) {
        return isValidInfo && this.front.fileList.length && this.back.fileList.length && this.self.fileList.length
      } else {
        return isValidInfo && this.front.fileList.length && this.self.fileList.length
      }
    },
    user () {
      return this.$store.getters.user
    },
    userOverview () {
      return this.$store.getters.userOverview
    },
    isId () {
      return this.form.type === 'ID'
    },
    userKyc () {
      return this.$store.getters.userKyc
    }
  },
  created () {
    for (let i = 1; i < 32; i++) {
      let value = i + ''
      if (i < 10) value = '0' + i
      this.optionsDay.push({ label: value, value: value })
    }
    for (let i = 1; i < 13; i++) {
      let value = i + ''
      if (i < 10) value = '0' + i
      this.optionsMonth.push({ label: value, value: value })
    }
    for (let i = 1940; i < 2010; i++) {
      const value = i + ''
      this.optionsYear.push({ label: value, value: value })
    }
  },
  mounted () {
    this.countryOptions = this.countries
    setTimeout(() => {
      const eles = document.getElementsByClassName('el-upload__input')
      for (let i = 0; i < eles.length; i++) {
        eles[i].setAttribute('capture', 'camera')
      }
    }, 1000)
    this.getUserKyc()
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.countryOptions = this.countries.filter(item => {
            return item.en_short_name.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.countryOptions = []
      }
    },
    getUserKyc () {
      this.isLoading = true
      this.$store.dispatch('getUserKyc').then(rs => {
        this.form.type = rs.kycType || 'ID'
        if (rs.kycStatus === this.kycStatus.REJECTED && rs.kycRejectMessage) this.kycRejectMessage = rs.kycRejectMessage
        this.form.nationalId = this.userKyc.kycNationalId
        this.form.fullname = this.userKyc.kycFullname
        this.form.dob = this.userKyc.dobTxt
        this.form.idNumber = this.userKyc.kycIdNumber
      }).finally(() => {
        this.isLoading = false
      })
    },
    handleRemoveFront (file) {
      this.$refs.frontImage.clearFiles()
      this.front.isHideUpload = false
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleUploadFront (file, fileList) {
      this.front.fileList = fileList
      if (file && fileList.length) this.front.isHideUpload = true
    },
    handleRemoveBack (file) {
      this.$refs.backImage.clearFiles()
      this.back.isHideUpload = false
    },
    handlePictureCardPreviewBack (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleUploadBack (file, fileList) {
      this.back.fileList = fileList
      if (file && fileList.length) this.back.isHideUpload = true
    },
    handleRemoveSelf (file) {
      this.$refs.selfImage.clearFiles()
      this.self.isHideUpload = false
    },
    handlePictureCardPreviewSelf (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleUploadSelf (file, fileList) {
      this.self.fileList = fileList
      if (file && fileList.length) this.self.isHideUpload = true
    },
    async upload () {
      if (!this.isValidated) return
      try {
        this.form.dob = this.dob.year + '-' + this.dob.month + '-' + this.dob.day
        this.isProcessing = true
        const frontBase64 = await this.convertBase64(this.front.fileList[0])
        const backBase64 = await this.convertBase64(this.back.fileList[0])
        const selfBase64 = await this.convertBase64(this.self.fileList[0])
        const data = {
          image1: frontBase64,
          image2: this.isId ? backBase64 : selfBase64,
          image3: selfBase64
        }
        this.form.dob = this.$moment(this.form.dob).unix() * 1000
        const bodyData = Object.assign(data, this.form)
        const rs = await this.$store.dispatch('uploadUserKyc', bodyData)
        if (rs.status) this.$store.dispatch('getUserKyc')
        this.isProcessing = false
      } catch (error) {
        console.log(error)
        this.isProcessing = false
      }
    },
    changeType () {
      console.log(this.form.type)
    },
    async convertBase64 (file) {
      let blob
      if (!file) return ''
      if (file.raw) {
        blob = file.raw
      } else if (file.url) {
        const data = await fetch(file.url)
        blob = await data.blob()
      } else {
        blob = file
      }
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)

        fileReader.onload = async () => {
          const newResult = await this.resizeImage(fileReader.result)
          resolve(newResult)
        }
        fileReader.onerror = (error) => {
          reject(error)
        }
      })
    },
    getBytesFromBase64 (img) {
      const buffer = Buffer.from(img.substring(img.indexOf(',') + 1))
      const result = buffer.length / 1e+6
      return result
    },
    resizeImage (base64Str, maxWidth = 1920, maxHeight = 1080) {
      return new Promise((resolve) => {
        const img = new Image()
        img.src = base64Str
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    }
  }
}
</script>
